/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBusinessModel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m12 .977 3.636 3.636L13 7.249v1.337L15.414 11h1.353l2.636-2.636L23.039 12l-3.636 3.637L16.767 13h-1.353L13 15.414v1.337l2.636 2.636L12 23.024l-3.636-3.637L11 16.751v-1.337L8.586 13H7.249l-2.636 2.637L.976 12l3.637-3.636L7.249 11h1.337L11 8.586V7.249L8.364 4.613zm0 4.444.808-.808L12 3.805l-.808.808zm0 4.993L10.414 12 12 13.586 13.586 12zM5.42 12l-.807-.808-.808.808.808.808zM12 18.58l-.808.807.808.808.808-.808zM18.595 12l.808.808.808-.808-.808-.808z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBusinessModel as BusinessModel };
